import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('Введите ваше имя'),
  lastName: Yup.string().trim().required('Введите вашу фамилию'),
  phone: Yup.string()
    .trim()
    .matches(/^\+?\d+$/, 'Неверный формат номера телефона')
    .required('Неверный формат номера телефона'),
  confirmationCode: Yup.string().trim().nullable().required('Введите код подтверждения'),
  password: Yup.string()
    .trim()
    .required('Введите пароль')
    .min(6, 'Пароль должен содержать минимум 6 символов'),
  confirmPassword: Yup.string()
    .trim()
    .required('Повторите пароль')
    .oneOf([Yup.ref('password')], 'Пароли должны совпадать'),
  agreePrivacyPolicy: Yup.boolean().oneOf(
    [true],
    'Вы должны согласиться с политикой конфиденциальности',
  ),
});
